interface EnvConfig {
  adultAges: {
    [key: string]: number;
  };
  countries: string[];
  languages: string[];
  libreApiUrl: string;
  clmApiUrl: string;
  supportedCountries: string[];
  environment: string;
  logLevel: string;
  mock: boolean;
  production: boolean;
}

export const _config = {} as EnvConfig;

export const getEnvConfig = async () => {
  const response = await fetch('/config.json', {
    method: 'GET',
    headers: {
      'Content-type': 'application/json',
    },
  });

  if (response.ok) {
    const data = await response.json();

    Object.assign(_config, data);
    return data;
  }

  throw new Error('Failed to load environment configuration');
};
